export const filter = {
  name: '',
  code: '',
  sku: '',
  price: '',
  currency_id: null,
  category_id: null,
  vat: '',
  measurement_id: null,
};